
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWhale as ObiWhaleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-whale.js';
 
 
 

 
 export const ObiWhale = createComponent({
   react: React,
   tagName: 'obi-whale',
   elementClass: ObiWhaleElement,
   events: {
     
   }
  });
 
 